import { useSelector } from 'react-redux';
import { toast } from 'sonner';
import ConfirmDeleteButton from '@/components/common/ConfirmDeleteButton';
import { useDeleteProjectGroupCommentMutation } from './comment.api.slice';
import { selectCurrentUser } from '../auth/auth.slice';

function DeleteProjectGroupComment({
  projectGroupId,
  userId,
  commentId,
}: {
  projectGroupId: string;
  userId: string;
  commentId: string;
}) {
  const { isAuthenticated, user } = useSelector(selectCurrentUser);
  const [deleteProjectGroupComment, { isLoading }] =
    useDeleteProjectGroupCommentMutation();

  const handleProjectGroupCommentDelete = async () => {
    try {
      await deleteProjectGroupComment({ projectGroupId, commentId }).unwrap();
      toast.success('Comment deleted');
    } catch (error) {
      toast.error('Failed to delete the comment. Please try again.');
    }
  };

  if (!isAuthenticated) {
    return <div />;
  }

  if (
    userId !== user?._id &&
    !user?.email.endsWith('@onefinitycnc.com') &&
    user?.isVerified
  ) {
    return <div />;
  }

  return (
    <ConfirmDeleteButton
      onConfirm={handleProjectGroupCommentDelete}
      disabled={isLoading}
      label="Delete comment"
      description="Are you sure you want to delete this comment? This action cannot be undone."
    />
  );
}

export default DeleteProjectGroupComment;
